<template>
    <div>
		<el-dialog 
		:lang="$i18n.locale" 
		:title="dialogTitle" 
		:visible.sync="popup"
		:close-on-click-modal="false" 
		width="980px"
		:append-to-body="true" 
		@close="handleDialogClose"
	>
		<el-form label-width="150px" :model="dialogForm" ref="OrderForm" :rules="rules" :inline="true">
            <el-form-item :label="$t('commonInfo.orderNoColumn')" prop="orderNo">
                <el-input v-model="dialogForm.orderNo" placeholder="请输入订单号" :disabled="true" style="width: 650px;"></el-input>
            </el-form-item>
			<el-form-item :label="$t('commonInfo.orderType')" prop="order_category">
				<el-input v-model="dialogForm.order_category" placeholder="请输入订单类型" :disabled="true" style="width: 650px;"></el-input>
			</el-form-item>
            <el-form-item v-if="dialogForm.clientAppointCount && dialogForm.clientAppointCount != ''" :label="dialogForm.order_category == 'FFM'?$t('ksaWhFBXOrderPage.packageAmount'):$t('commonInfo.expectedDeliveryQuantity')" prop="clientAppointCount">
				<el-tag type="primary">{{dialogForm.clientAppointCount}}</el-tag>
			</el-form-item>
			<el-form-item v-if="dialogForm.itemType === 'CARTON' && ['FBA', 'FBN', 'OWH'].includes(dialogForm.order_category)"
				:label="$t('commonInfo.pcsCount')" prop="pcsCount" :required="dialogForm.order_category === 'FBA'">
				<el-input v-model.trim="dialogForm.pcsCount" style="width: 650px;" clearable
					placeholder="所有箱内的商品总件数，非箱数或换标数量；FBA必填，其他选填"></el-input>
			</el-form-item>
			<el-form-item v-if="dialogForm.exp && dialogForm.exp != ''" :label="$t('commonInfo.remark')" prop="exp">
    			<el-tag type="info" style="width: 650px;">{{dialogForm.exp}}</el-tag>	
    		</el-form-item>

            <div v-if="dialogForm.order_category == 'OWH'">
              <el-form-item :label="$t('commonInfo.deliveryMode')" prop="deliveryType">
			  	<el-radio v-model="dialogForm.deliveryType" label="1">{{$t('commonInfo.homeDeliveryService')}}</el-radio>
			  	<el-radio v-model="dialogForm.deliveryType" label="2">{{$t('commonInfo.whSelfPickup')}}</el-radio>
			  </el-form-item>
			</div>
			<div v-if="dialogForm.order_category != '' && dialogForm.order_category != 'FFM'">
				<el-form-item v-if="dialogForm.order_category != 'DS'" :label="$t('commonInfo.warhouseCode')" prop="receiver_address">
					<el-tag v-if="dialogForm.deliveryType == '2'" type="success">{{$t('commonInfo.fleetanWarehouse')}}</el-tag>
					<el-select v-else v-model="dialogForm.receiver_address" filterable :placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryWarehouse')" style="width: 650px;">
						<el-option v-for="item in selectWhList" :key="item.dictCode" :label="item.dictLabel"
							:value="item.dictValue"></el-option>
					</el-select>
				</el-form-item>
				<CustomerAddressSelector
					:visible="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'"
					country="SA"
					@select="applyCustomerAddress" />
				<!-- OWH 送货上门 自定义仓库需要填写地址详情 -->
				<el-form-item v-if="dialogForm.receiver_address == 'custom' || dialogForm.deliveryType == '2'"  :label="$t('commonInfo.deliveryDest')" prop="receiver_detail_address">
    				<el-input style="width: 650px;" v-model="dialogForm.receiver_detail_address" :disabled="dialogForm.deliveryType == '2'"
    					:placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.deliveryDest')"></el-input>
    			</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'OWH' && dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom'"
    				:label="$t('commonInfo.city')" prop="destCity">
    				<el-select v-model="dialogForm.destCity" filterable
    					:placeholder="$t('tipsInfo.selectPlaceholder') + $t('commonInfo.city')"
    					style="width: 650px;">
    					<el-option v-for="item in saCityList" :key="item.dictCode" :label="item.dictLabel"
    						:value="item.dictLabel"></el-option>
    				</el-select>
    			</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')"  :label="dialogForm.deliveryType == '1'?$t('commonInfo.contactMan'):$t('commonInfo.consigneeTypeOne')" prop="contacts">
					<el-input v-model="dialogForm.contacts" clearable style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + (dialogForm.deliveryType == '1'?$t('commonInfo.contactMan'):$t('commonInfo.consigneeTypeOne'))"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.deliveryType == '2' || (dialogForm.deliveryType == '1' && dialogForm.receiver_address == 'custom')"  :label="dialogForm.deliveryType == '1'?$t('commonInfo.contact'):$t('commonInfo.consigneeContact')" prop="contactsTel">
					<el-input v-model="dialogForm.contactsTel" clearable style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + (dialogForm.deliveryType == '1'?$t('commonInfo.contact'):$t('commonInfo.consigneeContact'))"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNo')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBA'" :label="$t('commonInfo.fbaNoCode')" prop="fbaNoCode">
					<el-input v-model="dialogForm.fbaNoCode" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.fbaNoCode')"></el-input>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B'" :label="$t('commonInfo.asnNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.asnNo')"></el-input>
				</el-form-item>
				<!-- FBN SB2B DS订单类型需要填写店铺ID -->
				<el-form-item v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B' || dialogForm.order_category == 'DS'" :label="'NOON ' + $t('commonInfo.companyId')" prop="send_company">
					<el-input v-model="dialogForm.send_company" style="width: 650px;"></el-input>
				</el-form-item>
				<!-- OWH类型暂无法知道怎么填写该必传字段，先显示测试 -->
				<el-form-item v-if="dialogForm.order_category == 'OWH'" :label="$t('commonInfo.clientDeliveryNo')" prop="fba_no">
					<el-input v-model="dialogForm.fba_no" style="width: 650px;" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientDeliveryNo')"></el-input>
				</el-form-item>
			</div>
			<div v-if="dialogForm.order_category != ''">
				<el-form-item v-if="dialogForm.order_category == 'FFM'" :label="$t('ksaWhFBXOrderPage.deliveryPlatform')" prop="expressCompany">
					<el-select v-model="dialogForm.expressCompany" filterable :placeholder="$t('tipsInfo.selectPlaceholder') + $t('ksaWhFBXOrderPage.deliveryPlatform')" style="width: 650px;">
						<el-option v-for="item in deliveryPlatformList" :key="item.dictCode" :label="item.dictLabel"
							:value="item.dictValue"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="dialogForm.order_category != 'FBA'" :label="dialogForm.deliveryType == '1'?$t('commonInfo.deliveryDate'):$t('commonInfo.pickupDate') + '(SA)'" prop="delivery_date">
					<el-date-picker
					  clearable
					  style="width: 650px;"
						popper-class="no-atTheMoment"
					    v-model="dialogForm.delivery_date"
						:picker-options="deliveryPickerOptions"
					  :type="dialogForm.order_category == 'OWH'?'date':'datetime'"
					  value-format="yyyy-MM-dd HH:mm:ss"
					  :placeholder="dialogForm.deliveryType == '1'?$t('tipsInfo.selectPlaceholder') + $t('commonInfo.deliveryDate'):$t('tipsInfo.selectPlaceholder') + $t('commonInfo.pickupDate')"
					></el-date-picker>
				</el-form-item>
				<!-- 预约送仓时间提示 -->
				<div class="deliveryTip" v-if="dialogForm.order_category != 'FBA' && dialogForm.order_category != 'FFM'">
					<h4><i class="el-icon-warning"></i>预约送仓时间选择规则：</h4>
					<span>1、选择送仓时间为沙特时间</span>
					<span>2、每周五沙特公休</span>
					<span>3、国内推单当天时间0点-15点为正常推单，</span>
					<label>15点到20点为加急推单，需要收取加急费用，</label>
					<label>20点过后不能推当天单</label>
					<span>4、提前一天以上为正常推单</span>
				</div>
			</div>
		</el-form>
		<!-- 上传文件 -->
		<div style="margin: 10px 0 0 0; display: inline-block;">
			<!-- 上传FBX附件 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBA'"
			  v-model="fbxFlienName"
				:tipText="$t('commonInfo.labelFileTips')"
				:preFile="fbxPreName"
			  @input="getFBXInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 上传FBN/SB2B 送仓文件 和DS类型客户二维码和仓库二维码 -->
			<SingleUploadPDF
			  v-if="dialogForm.order_category == 'FBN' || dialogForm.order_category == 'SB2B' || dialogForm.order_category == 'DS'"
			  v-model="labelFlienName"
				:tipText="labelTipText"
				:preFile="labelPreName"
			  @input="getLabelInfo"
				class="fileUploadBtn"
			></SingleUploadPDF>
			<!-- 上传FFM 送仓文件 -->
			<MultiFunctionalUpload v-if="dialogForm.order_category == 'FFM'" ref="multiUploadFFMFile" @input="getFFMFile"
			 :tipText="labelTipText" :preFile="preFFMFileList" :fileCount="1">
			</MultiFunctionalUpload>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleDialogClose" :disabled="submitLoading">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
			<el-button type="primary" :loading="submitLoading" @click="submit" :disabled="submitLoading">{{submitLoading?$t('commonInfo.dialogBtnSubmiting'):$t('commonInfo.dialogBtnSubmit')}}</el-button>
		</div>
    </el-dialog>
    </div>
</template>

<script>
import SingleUploadPDF from "@/components/upload/singleUploadPDF";
import MultiFunctionalUpload from "@/components/upload/multiFunctionalUpload";
import CustomerAddressSelector from "@/components/customerAddress/CustomerAddressSelector";
export default {
  name: 'updateOrder',
  components: {
      SingleUploadPDF,
      MultiFunctionalUpload,
	  CustomerAddressSelector,
  },
  // 获取父组件信息
  props: {
    visible:{
    	type:Boolean,
    	default:function(){
    		return false;
    	}
    },
    rowData:{
    	type:Object,
    	default:function(){
    		return {};
    	}
    }
  },
  watch:{
  	//监听按钮名称和提示文字
  	'visible':{
  		handler(newValue){
  			this.popup = newValue;
  			if (newValue) {
  				this.dialogTitle = '修改FBX订单';
			    // 获取字典数据
			    this.getDictData();
				
  			}
  		},
  		immediate: true,
  	},
    'dialogForm.receiver_address': {
    	immediate: true,
    	handler(val) {
    		if (val != '' && val != null) {
    			this.getWhInfo(val); //获取仓库信息
    		}
    	}
    },
	'dialogForm.deliveryType': {
      immediate: true,
      handler(val) {
        this.dialogForm.contacts = '';
        this.dialogForm.contactsTel = '';
      	// 选择自提默认Fleetan海外仓地址
        if(val == '2'){
          this.dialogForm.receiver_address = 'Fleetan';
		  // 获取fleetan海外仓信息
		  this.getWhDict('Fleetan');
        }else{
          this.dialogForm.receiver_address = '';
		  this.getWhDict(this.dialogForm.order_category);

        }
      }
    },

  },
  //监听属性 类似于data概念
  computed:{
  	rules() {// 表单验证需要在计算属性定义，才能实现实时更新国际化提示信息
  	  //自定义验证规则 只能填写数字或者英文字母
  	  const validateCode = (rule, value, callback) => {
  	  	let reg = /[^\w\.\/]/ig
  	  	if (reg.test(value)) {
  	  	 callback(new Error('commonInfo.numberAndLetterLimit'))
  	  	} else {
  	  	 callback()
  	  	}
  	  };
  	  return {
        fba_no: [{
        	required: true,
        	message: this.$t('tipsInfo.inputPlaceholder') + this.$t('tipsInfo.info'),
        	trigger: 'blur'
        }, {
        	validator: validateCode,
        	trigger: 'blur',
        }],
        fbaNoCode: [{
        	required: true,
        	message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.fbaNoCode'),
        	trigger: 'blur'
        }, {
        	min: 8,
        	max: 8,
        	message: this.$t('commonInfo.fbaNoCodeLimit'),
        	trigger: 'change'
        }, {
        	validator: validateCode,
        	trigger: 'blur',
        }],
        pcsCount: [{
          validator: (rule, value, callback) => {
            const text = value == null ? '' : String(value).trim();
            if (!text) {
              return callback(this.dialogForm.order_category === 'FBA' ? new Error('请填写PCS数量') : undefined);
            }
            if (!/^[0-9]+$/.test(text) || Number(text) <= 0 || Number(text) > 2147483647) {
              return callback(new Error('PCS数量必须为正整数，且不能超过2147483647'));
            }
            callback();
          },
          trigger: 'blur'
        }],
        delivery_date: [{
        	required: true,
        	message: this.dialogForm.deliveryType == '1' ? this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.deliveryDate') : this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.pickupDate'),
        	trigger: 'blur'
        }],
        send_company: [{
        	required: true,
        	message: this.$t('tipsInfo.inputPlaceholder') + 'NOON ' + this.$t('commonInfo.companyId'),
        	trigger: 'blur'
        }, {
        	min: 5,
        	max: 6,
        	message: this.$t('commonInfo.companyLimit'),
        	trigger: 'blur'
        }],
        receiver_address: [{
        	required: true,
        	message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.warhouseCode'),
        	trigger: 'blur'
        }],
        contacts: [{
          required: true,
          message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contactMan') : this.$t('commonInfo.consigneeTypeOne')),
          trigger: 'blur'
        }],
        contactsTel: [{
          required: true,
          message: this.$t('tipsInfo.inputPlaceholder') + (this.dialogForm.deliveryType == '1' ? this.$t('commonInfo.contact') : this.$t('commonInfo.consigneeContact')),
          trigger: 'blur'
        }],
		receiver_detail_address: [{
          required: true,
          message: this.$t('tipsInfo.inputPlaceholder') + this.$t('commonInfo.deliveryDest'),
          trigger: 'blur'
        }],
		destCity: [{
          required: true,
          message: this.$t('tipsInfo.selectPlaceholder') + this.$t('commonInfo.city'),
          trigger: 'blur'
        }],
  		}
  	},
  },
  data() {
    return {
      popup: false,
	  submitLoading:false,
      // 订单信息
      dialogTitle: '修改订单',
      selectWhList: [],
	  saCityList: [],
      deliveryPlatformList: [],
      dialogLoading: false,
      dialogForm: {
        id: '',
		orderNo: '', // 订单号
		order_category:'',
		itemType: '',
		pcsCount: '',
		deliveryType:'1',//派送方式 默认送货上门

      	label_url: '',//送仓文件
		order_box_mark: '',//箱唛
      	fba_no: '',
      	fbaNoCode: '',
      	delivery_date: null,
      	receiver_address: '',
      	receiver_detail_address: '',
      	send_company: '',//店铺ID
        contacts: '',//联系人或提货人
        contactsTel: '',//联系人电话或联系人电话
        expressCompany: '',// ffm 派送平台
		destCity:'',//目的城市
		exp:'',//备注
      },

      fileList: [],
      fbxFlienName: '',//上传FBX文件名称
      fbxLink: '',//上传FBX的路径
      fbxPreName: [],//fbx上传的预览文件名集合
      labelFlienName: '',//上传送仓文件名称
      labelLink: '',//上传送仓文件的路径
      labelPreName: [],//送仓文件上传的预览文件名集合
      labelTipText: '送仓文件-只能上传PDF文件',//按钮描述，FBN/SB2B 和DS订单类型按钮描述不一样

      preFFMFileList: [],
      ffmFileLink: '',
	  deliveryPickerOptions: {
		disabledDate(time) {
		    let nowDate = Date.now();
			let nowHour = new Date().getHours();
			if(nowHour < 15) {
				nowDate = nowDate - 24 * 60 * 60 * 1000;
			} else if(nowHour >= 15 && nowHour < 20) {
		    	nowDate = nowDate - 24 * 60 * 60 * 1000;
			}
			let nowDay = new Date(time).getDay();
				return nowDate > time.getTime() || nowDay == 5;
			},
			selectableRange: '10:00:00 - 18:00:00'
		},
    };
  },
  methods: {
	applyCustomerAddress(address) {
		this.dialogForm.destCity = address.city;
		this.dialogForm.receiver_detail_address = address.detailAddress;
		this.dialogForm.contacts = address.contactPerson;
		this.dialogForm.contactsTel = address.contactPhone;
	},
    // 加载字典
	async getDictData() {
		this.getWhDict(this.rowData.orderType);
	    // 获取城市字典
    	if (this.saCityList.length == 0) {
    		// 获取B2B空运城市地址 sys_b2bAirCity_list
			const cityRes = await this.$http.get("/toborder/system/dict/data/list", {params: {
					page: 1,
					limit: 100,
					dictType: 'sys_b2bAirCity_list'
				}
			});
			if (cityRes.code === 200) {
				this.saCityList = cityRes.rows;
			} else {
				this.$message.error(cityRes.msg);
			}
    	}
    	
    	// 获取派送平台
		if (this.deliveryPlatformList.length == 0) {
		    const res = await this.$http.get("/toborder/system/dict/data/list",{ params: {
				page:1,
				limit:100,
				dictType:'sys_ffm_delivery_platform'
			}});
			if (res.code === 200) {
				this.deliveryPlatformList = res.rows;
			} else {
			  this.$message.error(res.msg);
			}
		}

    	this.loadOrderData();
    	
	},
    // 加载订单数据
    loadOrderData() {
		let that = this;
    	setTimeout(() => {
			that.dialogForm.id = that.rowData.id;
			that.dialogForm.orderNo = that.rowData.customerOrderNo;
			that.dialogForm.order_category = that.rowData.orderType;
			that.dialogForm.itemType = that.rowData.itemType;
			that.dialogForm.pcsCount = that.rowData.pcsCount == null ? '' : String(that.rowData.pcsCount);
			that.dialogForm.deliveryType = that.rowData.deliveryType;
			that.dialogForm.clientAppointCount = that.rowData.clientAppointCount;
			that.dialogForm.exp = that.rowData.exp;
			that.dialogForm.receiver_address = that.rowData.receiverAddress;
			setTimeout(() => {
			  that.dialogForm.destCity = that.rowData.destCity;
			  that.dialogForm.contacts = that.rowData.contacts;
			  that.dialogForm.contactsTel = that.rowData.contactsTel;
			  that.dialogForm.receiver_detail_address = that.rowData.receiverDetailAddress;
			  // 将字符串转换为Date对象
			  that.dialogForm.delivery_date = that.rowData.deliveryDate + ':00';
			  that.dialogForm.fba_no = that.rowData.fbaNo;
			  that.dialogForm.fbaNoCode = that.rowData.fbaNoCode;
			  that.dialogForm.send_company = that.rowData.sendCompany;
			  that.dialogForm.expressCompany = that.rowData.expressCompany;
			  // 显示上传文件
			  if(that.rowData.orderType == 'FBA') {
				  that.fbxLink = that.rowData.fbaBoxPdfLink;
			      that.fbxPreName = [{
					// name获取链接最后一个~后面的内容
					name: decodeURIComponent(that.rowData.fbaBoxPdfLink.split('~').pop()),
					url: that.rowData.fbaBoxPdfLink,
				  }]
			  }
			  if(that.rowData.orderType == 'FBN') {
				  that.labelLink = that.rowData.labelUrl;
			      that.labelPreName = [{
					// name获取链接最后一个~后面的内容
					name: decodeURIComponent(that.rowData.labelUrl.split('~').pop()),
					url: that.rowData.labelUrl,
				  }]
			  }
			  if(that.rowData.orderType == 'FFM') {
				  that.ffmFileLink = that.rowData.labelUrl;
			      that.preFFMFileList = [{
					// name获取链接最后一个~后面的内容
					name: decodeURIComponent(that.rowData.labelUrl.split('~').pop()),
					url: that.rowData.labelUrl,
				  }]
			  }
			},300)
		}, 300);
    },
	//选择仓库时自定填充仓库地址信息
    getWhInfo(val) {
    	this.selectWhList.forEach(item => {
				if(val == 'custom'){
					// 自定义仓库清空详细地址 和联系人信息
					this.dialogForm.receiver_detail_address = '';
					this.dialogForm.contacts = '';
					this.dialogForm.contactsTel = '';
				}else if (item.dictValue == val) {
					if (item.dictValue == val) {
					let address = '', whCity = '';
					if(item.remark && item.remark.includes('&&&')){
						address = item.remark.split('&&&')[0];
						whCity = item.remark.split('&&&')[1];
					}else{
						address = item.remark;
					}
					this.dialogForm.receiver_detail_address = address;
				    this.dialogForm.destCity = whCity;
					}
				}
    		})
    },
    
    // 获取仓库数据
    getWhDict(type) {
    	let dictText = '';
    	switch (type) {
    		case 'FBA':
    			dictText = 'sys_SA_FBAWh';
    			break;
    		case 'FBN':
    			dictText = 'sys_SA_NOONWh';
    			this.labelTipText = '送仓文件-只能上传PDF文件';
    			break;
    		case 'SB2B':
    			dictText = 'sys_SA_NOONWh';
    			this.labelTipText = '送仓文件-只能上传PDF文件';
    			break;
    		case 'OWH':
    			dictText = 'sys_SA_OtherWh';
    			break;
    		case 'DS':
    			dictText = 'sys_SA_OtherWh';
    			this.labelTipText = '客户二维码和仓库二维码-只能上传PDF文件';
    			break;
			// 自提 仓库信息默认fleetan海外仓
			case 'Fleetan':
    			dictText = 'sys_SA_FleetanWh';
    			break;
    	}
      if (dictText != '') {
		this.$http.get("/toborder/system/dict/data/list?dictType=" + dictText).then(res => {
		if (res.code == 200) {
			this.selectWhList = res.rows;
			if (type == 'Fleetan') {// 如果为自提类型，默认上传固定仓库信息，不需要显示
			    let address = this.selectWhList[0].remark.split('###')[0];
					let city = this.selectWhList[0].remark.split('###')[3];
        			this.dialogForm.receiver_detail_address = address;
					this.dialogForm.destCity = city;
    			}
				} else {
					this.$message.error(res.msg);
				}
			}).catch(err => {
				this.$message.error(err.msg);
			})
      }
    },
	getFBXInfo(data) {
		this.fbxLink = data;
		if(data != ''){
			//修改upload的preview预览
			let str = data.split("~");
			this.fbxPreName = [{
	    		name:str[1],
				url:data,
			}]
		}
	},
	getLabelInfo(data) {
		this.labelLink = data;
		if(data != ''){
			//修改upload的preview预览
			let str = data.split("~");
			this.labelPreName = [{
				name:str[1],
				url:data,
		    }]
		}
	},
	getFFMFile(data){
		this.ffmFileLink = '';
		if (data.length > 0) {
			this.preFFMFileList = data;
			this.ffmFileLink = data[0].url;
		}
	},
	submit() {
		if(this.dialogForm.order_category == 'FBA'){
			if(this.fbxLink == '' || this.fbxLink == null){
			    this.$message.warning(this.$t('tipsInfo.submitOrderDeliveryMarkTips'));
		    	return; 
			}
		}
		if(this.dialogForm.order_category == 'FBN' || this.dialogForm.order_category == 'SB2B' || this.dialogForm.order_category == 'DS'){
			if(this.labelLink == '' || this.labelLink == null){
				this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.labelTipText.split('-')[0]);
				return; 
			}
		}
		if(this.dialogForm.order_category == 'FFM'){
			if(this.ffmFileLink == '' || this.ffmFileLink == null){
				this.$message.warning(this.$t('ksaWhFBXOrderPage.uploadPreTips') + this.$t('commonInfo.deliveryFile'));
				return; 
			}
		}
		this.dialogForm.order_box_mark = this.fbxLink;
		if(this.dialogForm.order_category == 'FFM'){
           this.dialogForm.label_url = this.ffmFileLink;
		}else if (this.dialogForm.order_category == 'FBN' || this.dialogForm.order_category == 'SB2B' || this.dialogForm.order_category == 'DS'){
			this.dialogForm.label_url = this.labelLink;
		}
		this.dialogForm.fulfillmentFileUrl = this.ffmFileLink;//FFM文件
      
		// 提交
		this.$refs["OrderForm"].validate(valid => {
			if (valid) {
				this.handleUpdateOrder();
			}
		});
	},
	// 提交更新订单
	handleUpdateOrder() {
		this.submitLoading = true;
		this.$http.post('/toborder/wms/fulfillment/updateDeliveryInfo',this.dialogForm).then(res => {
			if (res.code == 200) {
				this.submitLoading = false;
				this.$message.success(this.$t("tipsInfo.operationSuccess"));
				this.$parent.getList();
				this.handleDialogClose();
			} else {
				this.submitLoading = false;
				this.$message.error(res.msg);
			}
		}).catch(err => {
		    this.submitLoading = false;
			this.$message.error(err.msg);
		})
		;
	},
    //关闭窗口
    handleDialogClose() {
      this.popup = false;
      this.$parent.currentOrderData = {};
      this.$parent.updateOrderPopup = false;
    }
  },
  created() {
      
  }
};
</script>

<style scoped>
.deliveryTip {
	width: 630px;
	margin-left: 150px;
	margin-bottom: 10px;
	background-color: #fffdd6;
	border-radius: 4px;
	padding: 5px 10px;
}

.deliveryTip h4 {
	margin: 0;
	line-height: 30px;
}

.deliveryTip i {
	margin: 0 5px;
}

.deliveryTip span {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 20px;
}

.deliveryTip label {
	display: block;
	height: 20px;
	line-height: 20px;
	text-indent: 40px;
	font-weight: bold;
}

.fileUploadBtn {
	float: left;
	margin: 0 10px;
	max-width: 220px;
}

.dialog-footer {
	text-align: center;
}

/* 阿拉伯语样式 */
[lang="ar"] {
	.deliveryTip {
		margin-left: 0;
		margin-right: 150px;
	}
	
	.fileUploadBtn {
		float: right;
		margin: 0 10px;
		max-width: 220px;
	}
	
	::v-deep .el-dialog__headerbtn {
		right: auto;
		left: 20px;
	}
	
	::v-deep .el-dialog__footer {
		text-align: left;
		.el-button {
			margin: 0 10px;
		}
	}
}
</style>
